/**
 * Model definition for credit-calculator
 */

import {
  ConfigurationType,
  CreditUsage,
  ProductSelectionVisibility,
} from '@portals/skp-calculator/src/contexts/configuration';

export interface SkpCreditCalculator {
  __component: 'skp.credit-calculator';
  id: string;
  configurationType: ConfigurationType;
  defaultUsage: CreditUsage;
  default: ProductSelectionVisibility;
  defaultLoanTerm: number;
  defaultLoanAmount: number;
  ctaButtonVisible: boolean;
  headlineVisible: boolean;
  creditValueMin: number;
  creditValueMax: number;
  durationValueMin: number;
  durationValueMax: number;
}

export function isSkpCreditCalculator(obj: { __component?: string }): obj is SkpCreditCalculator {
  return obj.__component === 'skp.credit-calculator';
}
